<div class="main-container">
  <div class="checkbox-item-main-container" cdkDropList (cdkDropListDropped)="positionOfItemChanged($event)">
    <!-- Select All Checkbox -->
    <div class="checkbox-item">
      <input type="checkbox" class="checkbox" [checked]="allSelected" (change)="toggleSelectAll($event)">
      <p class="fw-bold checkbox-label" style="color: var(--text-color-gray);">Select All</p>
    </div>

    <div class="checkbox-item" *ngFor="let item of listOfItems; index as i" cdkDrag>
      <input type="checkbox" class="checkbox" [checked]="item.checked" (click)="checkListItem(i , item.checked)">

      <p *ngIf="item.addedByUser === false" class="checkbox-label">{{item.name}}</p>
      <input *ngIf="item.addedByUser === true" type="text" [(ngModel)]="item.name" (ngModelChange)="itemInputTextChanged()" class="input-text">
      <span class="badge" [ngClass]="{'dmc-badge' : item.userType === 'DMC' }" *ngIf="item.userType">
        {{ item.userType }}
      </span>
      <button class="list-action-btn filled-blue" *ngIf="showDefaultActionButton && role === USER_ROLES.CLIENT_ADMIN && item.addedByUser === true" type="button" (click)="setDefault(item)">Set Default</button>
      <button class="list-action-btn unfilled-red" *ngIf="showDefaultActionButton && role === USER_ROLES.CLIENT_ADMIN && item.addedByUser === false" type="button" (click)="removeDefault(item)">Remove Default</button>

      <button type="button" class="delete-btn" *ngIf="item.addedByUser === true" (click)="deleteItem(i)">-</button>
    </div>
  </div>

  <div>
    <div class="w-fit-content d-flex">
      <ion-button class="filled-blue-btn" (click)="openMultiPointModal()">{{addButtonText}}</ion-button>
    </div>
  </div>
</div>